<template>
  <Layout tituloPagina="Sistema | Ajustes | Facturación">
    <div class="row mb-2">
      <div class="col-lg-4">
        <CmpTabs />
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="card-header justify-content-between d-flex align-items-center border-bottom">
        <div>
          <h4 class="card-title mb-1 d-flex align-items-center">
            <i class="mdi mdi-receipt-text-outline text-primary me-2 font-size-22"></i>
            Ajustes de Facturación
          </h4>
          <p class="text-muted mb-0 font-size-13">
            Configuración global de reglas de facturación, cobro, recargos y políticas del sistema.
          </p>
        </div>
        <div>
          <div class="dropdown">
            <a
              class="dropdown-toggle"
              href="javascript: void(0);"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <eva-icon
                name="more-horizontal-outline"
                data-eva-width="20"
                data-eva-height="20"
                :class="{
                  'fill-dark': $store.state.layout.layoutMode == 'light',
                  'fill-white': $store.state.layout.layoutMode == 'dark'
                }"
              ></eva-icon>
            </a>
            <ul class="dropdown-menu dropdown-menu-end shadow">
              <li>
                <a
                  href="#"
                  class="dropdown-item"
                  onclick="return false"
                  @click="actualizar()"
                  v-if="!bandera_spinner"
                >
                  <i class="mdi mdi-content-save text-success me-1"></i>
                  Actualizar
                </a>
                <span class="dropdown-item disabled" v-if="bandera_spinner">
                  <i class="mdi mdi-loading mdi-spin me-1"></i>
                  Actualizando...
                </span>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  href="#"
                  onclick="return false;"
                  @click="$router.go(-1)"
                >
                  <i class="mdi mdi-close text-secondary me-1"></i>
                  Cerrar
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card-body p-4">
        <!-- Spinner de carga inicial -->
        <div v-if="cargando_ajustes" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <p class="text-muted mt-2">Cargando configuración de facturación...</p>
        </div>

        <div v-else>
          <!-- SECCIÓN 1: Modelo de Renta y Cobro -->
          <div class="mb-4">
            <h5 class="text-primary font-size-15 mb-3 d-flex align-items-center">
              <i class="mdi mdi-credit-card-outline me-2 font-size-18"></i>
              Modelo de Renta y Cobro
            </h5>

            <div class="row g-3">
              <!-- Tipo de renta -->
              <div class="col-md-4">
                <label class="form-label font-weight-bold">Tipo de renta</label>
                <select v-model="ajustes.id_tipo_renta" class="form-select">
                  <option :value="1">Renta mensual fija</option>
                  <option :value="2">Renta mensual variable</option>
                </select>
                <small class="form-text text-muted">
                  Define si las mensualidades tienen un valor invariable o varían periódicamente.
                </small>
              </div>

              <!-- Tipo de cobro -->
              <div class="col-md-4">
                <label class="form-label font-weight-bold">Modalidad de cobro</label>
                <select class="form-select" v-model="ajustes.prepago">
                  <option :value="1">Prepago (Cobro por adelantado)</option>
                  <option :value="0">Pospago (Cobro a mes vencido)</option>
                </select>
                <small class="form-text text-muted">
                  Momento en que se requiere el pago respecto al periodo de servicio.
                </small>
              </div>

              <!-- Día de pago -->
              <div class="col-md-4">
                <label class="form-label font-weight-bold">
                  Día límite de pago
                  <i class="mdi mdi-help-circle-outline text-muted" title="Día del mes programado como fecha límite de pago para los clientes"></i>
                </label>
                <div class="input-group">
                  <span class="input-group-text bg-light text-muted">
                    <i class="mdi mdi-calendar-alert"></i>
                  </span>
                  <input
                    type="number"
                    min="1"
                    max="31"
                    class="form-control text-end"
                    v-model.number="ajustes.dia_pago_servicios"
                    placeholder="1"
                    onkeypress="return check(event, 'enteros')"
                  />
                  <span class="input-group-text bg-light">
                    del mes
                  </span>
                </div>
                <small class="form-text text-muted">
                  Fecha límite mensual de pago para los contratos activos.
                </small>
              </div>
            </div>
          </div>

          <hr class="my-4 text-muted opacity-25" />

          <!-- SECCIÓN 2: Costos e Instalación -->
          <div class="mb-4">
            <h5 class="text-primary font-size-15 mb-3 d-flex align-items-center">
              <i class="mdi mdi-tools me-2 font-size-18"></i>
              Instalación y Costos Iniciales
            </h5>

            <div class="row g-3">
              <!-- Precio de instalación -->
              <div class="col-md-4">
                <label class="form-label font-weight-bold">Precio de instalación predeterminado</label>
                <div class="input-group">
                  <span class="input-group-text bg-light text-muted">
                    {{ monedaSistema.simbolo || '$' }}
                  </span>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    v-model.number="ajustes.precio_instalacion"
                    class="form-control text-end"
                    placeholder="0.00"
                  />
                  <span class="input-group-text bg-light">
                    {{ monedaSistema.codigo || 'MXN' }}
                  </span>
                </div>
                <small class="form-text text-muted">
                  Costo base aplicado al registrar nuevas solicitudes o contratos.
                </small>
              </div>

              <!-- Meses incluidos en instalación -->
              <div class="col-md-4">
                <label class="form-label font-weight-bold">Meses de servicio incluidos</label>
                <div class="input-group">
                  <span class="input-group-text bg-light text-muted">
                    <i class="mdi mdi-calendar-range"></i>
                  </span>
                  <input
                    type="number"
                    min="0"
                    v-model.number="ajustes.meses_incluidos_en_instalacion"
                    @change="
                      ajustes.meses_incluidos_en_instalacion < 0
                        ? (ajustes.meses_incluidos_en_instalacion = 0)
                        : null
                    "
                    class="form-control text-end"
                    placeholder="0"
                  />
                  <span class="input-group-text bg-light">
                    mes(es)
                  </span>
                </div>
                <small class="form-text text-muted">
                  Meses de servicio de cortesía al cubrir el costo de instalación.
                </small>
              </div>
            </div>
          </div>

          <hr class="my-4 text-muted opacity-25" />

          <!-- SECCIÓN 3: Cargos por Mora -->
          <div class="mb-4">
            <h5 class="text-primary font-size-15 mb-3 d-flex align-items-center">
              <i class="mdi mdi-cash-plus me-2 font-size-18"></i>
              Recargos y Cargos por Mora
            </h5>

            <div class="row g-3">
              <!-- Cargos por mora para nuevos contratos -->
              <div class="col-md-4">
                <label class="form-label font-weight-bold">Cargos por mora en nuevos contratos</label>
                <select class="form-select" v-model="ajustes.cargos_por_mora">
                  <option :value="0">Deshabilitado (No aplicar)</option>
                  <option :value="1">Habilitado (Aplicar recargo)</option>
                </select>
                <small class="form-text text-muted">
                  Habilita el cobro de recargos por mora por defecto en nuevos clientes.
                </small>
              </div>

              <!-- Importe de cargos por mora -->
              <div class="col-md-4">
                <label class="form-label font-weight-bold">Importe de cargo por mora</label>
                <div class="input-group">
                  <span class="input-group-text bg-light text-muted">
                    {{ monedaSistema.simbolo || '$' }}
                  </span>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    placeholder="0.00"
                    class="form-control text-end"
                    v-model.number="ajustes.importe_cargos_por_mora"
                    :disabled="!Number(ajustes.cargos_por_mora)"
                  />
                  <span class="input-group-text bg-light">
                    {{ monedaSistema.codigo || 'MXN' }}
                  </span>
                </div>
                <small class="form-text text-muted">
                  Monto penalizado que se sumará a las facturas que presenten retraso.
                </small>
              </div>
            </div>
          </div>

          <hr class="my-4 text-muted opacity-25" />

          <!-- SECCIÓN 4: Automatización de Generación y Prórrogas -->
          <div class="mb-4">
            <h5 class="text-primary font-size-15 mb-3 d-flex align-items-center">
              <i class="mdi mdi-calendar-sync-outline me-2 font-size-18"></i>
              Generación Automática y Prórrogas
            </h5>

            <div class="row g-3">
              <!-- Días antes para generar factura -->
              <div class="col-md-4">
                <label class="form-label font-weight-bold">Generación anticipada de facturas</label>
                <div class="input-group">
                  <input
                    type="number"
                    min="0"
                    class="form-control text-end"
                    v-model.number="ajustes.dias_antes_generar_facturas"
                    placeholder="1"
                    onkeypress="return check(event, 'enteros')"
                  />
                  <span class="input-group-text bg-light">
                    días antes del día de pago
                  </span>
                </div>
                <small class="form-text text-muted">
                  Anticipación con la que se creará y notificará la factura al cliente.
                </small>
              </div>

              <!-- Hora de generación -->
              <div class="col-md-4">
                <label class="form-label font-weight-bold">Hora de emisión de facturas</label>
                <div class="input-group">
                  <span class="input-group-text bg-light text-muted">
                    <i class="mdi mdi-clock-outline"></i>
                  </span>
                  <input
                    type="time"
                    step="1"
                    class="form-control text-center"
                    v-model="ajustes.hora_generar_facturas"
                    placeholder="00:00:00"
                  />
                  <span class="input-group-text bg-light">
                    Hrs.
                  </span>
                </div>
                <small class="form-text text-muted">
                  Hora en que se ejecuta la tarea programada de facturación.
                </small>
              </div>

              <!-- Plazo máximo de prórroga -->
              <div class="col-md-4">
                <label class="form-label font-weight-bold">Plazo máximo permitido para prórroga</label>
                <div class="input-group">
                  <select
                    class="form-select text-end"
                    v-model.number="ajustes.dias_maximo_prorroga_facturas"
                  >
                    <option v-for="n in 90" :value="n" :key="'d-m-p-f-' + n">
                      {{ n }}
                    </option>
                  </select>
                  <span class="input-group-text bg-light">
                    días máx. tras vencimiento
                  </span>
                </div>
                <small class="form-text text-muted">
                  Límite máximo de días que un usuario puede otorgar de extensión de pago.
                </small>
              </div>
            </div>
          </div>

          <hr class="my-4 text-muted opacity-25" />

          <!-- SECCIÓN 5: Políticas y Comportamiento del Sistema -->
          <div class="mb-2">
            <h5 class="text-primary font-size-15 mb-3 d-flex align-items-center">
              <i class="mdi mdi-cog-sync-outline me-2 font-size-18"></i>
              Políticas y Comportamiento del Sistema
            </h5>

            <div class="row g-3">
              <!-- Switch Saldo a favor -->
              <div class="col-md-6">
                <div class="card border rounded-3 p-3 h-100 bg-light">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <div class="d-flex align-items-center">
                      <div class="avatar-xs me-2">
                        <span class="avatar-title bg-soft-success text-success rounded-circle font-size-16">
                          <i class="mdi mdi-wallet-plus-outline"></i>
                        </span>
                      </div>
                      <h6 class="font-size-14 font-weight-bold mb-0 text-dark">
                        Usar saldo a favor automáticamente
                      </h6>
                    </div>
                    <div class="form-check form-switch form-switch-md mb-0">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="saldoAFavor"
                        :checked="ajustes.aplicar_saldo_favor_a_facturas_pendientes_pago"
                        @change="
                          ajustes.aplicar_saldo_favor_a_facturas_pendientes_pago = !ajustes.aplicar_saldo_favor_a_facturas_pendientes_pago
                        "
                      />
                      <label class="form-check-label visually-hidden" for="saldoAFavor"></label>
                    </div>
                  </div>
                  <p class="text-muted font-size-13 mb-0">
                    Si la cuenta del cliente dispone de saldo a favor, se aplicará automáticamente como pago total o parcial al generarse una nueva factura.
                  </p>
                </div>
              </div>

              <!-- Switch Facturas vivas -->
              <div class="col-md-6">
                <div class="card border rounded-3 p-3 h-100 bg-light">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <div class="d-flex align-items-center">
                      <div class="avatar-xs me-2">
                        <span class="avatar-title bg-soft-warning text-warning rounded-circle font-size-16">
                          <i class="mdi mdi-file-document-outline"></i>
                        </span>
                      </div>
                      <h6 class="font-size-14 font-weight-bold mb-0 text-dark">
                        Mantener facturas vivas al retirar cliente
                      </h6>
                    </div>
                    <div class="form-check form-switch form-switch-md mb-0">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="facturasVivasClientes"
                        :checked="ajustes.facturas_vivas_clientes"
                        @change="
                          ajustes.facturas_vivas_clientes = !ajustes.facturas_vivas_clientes
                        "
                      />
                      <label class="form-check-label visually-hidden" for="facturasVivasClientes"></label>
                    </div>
                  </div>
                  <p class="text-muted font-size-13 mb-0">
                    Al dar de baja o retirar un cliente del sistema, sus facturas pendientes permanecerán activas y disponibles para posterior cobro o gestión contable.
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Botones de Acción -->
    <div class="text-right">
      <div class="btn-group">
        <button 
          class="btn btn-secondary px-3"
          @click="$router.go(-1)"
        >
          <i class="mdi mdi-chevron-left me-1"></i>
          Atras
        </button>
        <button 
          class="btn btn-success px-4" 
          @click="actualizar()" 
          :disabled="bandera_spinner || cargando_ajustes"
        >
          <i
            class="mdi"
            :class="!bandera_spinner ? 'mdi-content-save' : 'mdi-concourse-ci mdi-spin'"
          ></i>
          {{ bandera_spinner ? 'Guardando...' : 'Actualizar' }}
        </button>
      </div>
    </div>
    <br />
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main'
import SistemaSrv from '@/services/SistemaSrv.js'
import CmpTabs from './CmpTabs.vue'

export default {
  name: 'Facturacion',
  components: {
    Layout,
    CmpTabs
  },
  data() {
    return {
      ajustes: {
        id_tipo_renta: 1,
        prepago: 1,
        cargos_por_mora: 0,
        importe_cargos_por_mora: 0,
        meses_incluidos_en_instalacion: 0,
        precio_instalacion: 0,
        dia_pago_servicios: 1,
        dias_antes_generar_facturas: 1,
        hora_generar_facturas: "00:00:00",
        dias_maximo_prorroga_facturas: 1,
        aplicar_saldo_favor_a_facturas_pendientes_pago: false,
        facturas_vivas_clientes: false
      },
      bandera_spinner: false,
      cargando_ajustes: false
    }
  },
  computed: {
    monedaSistema() {
      return this.$store.state.todo?.moneda_sistema || { simbolo: '$', codigo: 'MXN' }
    }
  },
  created() {
    this.refrescarAjustes()
  },
  methods: {
    validarFormulario() {
      const dia = Number(this.ajustes.dia_pago_servicios)
      if (isNaN(dia) || dia < 1 || dia > 31) {
        iu.msg.error('Por favor indique un día de pago válido (entre 1 y 31).')
        return false
      }
      if (Number(this.ajustes.dias_antes_generar_facturas) < 0) {
        iu.msg.error('Los días antes de generar facturas no pueden ser negativos.')
        return false
      }
      if (Number(this.ajustes.precio_instalacion) < 0) {
        iu.msg.error('El precio de instalación no puede ser negativo.')
        return false
      }
      if (Number(this.ajustes.importe_cargos_por_mora) < 0) {
        iu.msg.error('El importe de cargos por mora no puede ser negativo.')
        return false
      }
      return true
    },

    actualizar() {
      if (!this.validarFormulario()) return

      let self = this
      let ajustes = Object.assign({}, self.ajustes)

      self.bandera_spinner = true

      SistemaSrv.actualizar(ajustes).then(() => {
        iu.msg.success('Los datos de facturación se han actualizado correctamente.')
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se pudieron actualizar los datos de facturación.'
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        self.bandera_spinner = false
      })
    },

    refrescarAjustes() {
      let self = this
      let ajustesSolicitados = Object.keys(self.ajustes)

      self.cargando_ajustes = true

      SistemaSrv.ajustes(ajustesSolicitados).then(response => {
        let ajustes = response.data || {}
        Object.assign(self.ajustes, ajustes)

        // Normalización de tipos de datos numéricos / booleanos
        self.ajustes.id_tipo_renta = Number(ajustes.id_tipo_renta) || 1
        self.ajustes.prepago = ["1", 1, "true", true].includes(ajustes.prepago)
        self.ajustes.cargos_por_mora = ["1", 1, "true", true].includes(ajustes.cargos_por_mora)
        self.ajustes.aplicar_saldo_favor_a_facturas_pendientes_pago = ["1", 1, "true", true].includes(ajustes.aplicar_saldo_favor_a_facturas_pendientes_pago)
        self.ajustes.facturas_vivas_clientes = ["1", 1, "true", true].includes(ajustes.facturas_vivas_clientes)
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No fue posible obtener la configuración de facturación.'
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        self.cargando_ajustes = false
      })
    }
  }
}
</script>

<style scoped>
.avatar-xs {
  height: 1.75rem;
  width: 1.75rem;
}

.avatar-title {
  align-items: center;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.18) !important;
}

.bg-soft-warning {
  background-color: rgba(241, 180, 76, 0.18) !important;
}

.form-check-input:checked {
  background-color: #63ad6f;
  border-color: #63ad6f;
}
</style>